import { render, staticRenderFns } from "./ReviewStars.vue?vue&type=template&id=47dad322&scoped=true"
import script from "./ReviewStars.vue?vue&type=script&lang=js"
export * from "./ReviewStars.vue?vue&type=script&lang=js"
import style0 from "./ReviewStars.vue?vue&type=style&index=0&id=47dad322&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47dad322",
  null
  
)

export default component.exports